import { render, staticRenderFns } from "./Fratrie.vue?vue&type=template&id=89fc5da2&scoped=true"
import script from "./Fratrie.vue?vue&type=script&lang=js"
export * from "./Fratrie.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=89fc5da2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fc5da2",
  null
  
)

export default component.exports